import {KecPath, Service, Version, source} from './constants';

export const kecDescribeInstances = {
    basePath: KecPath,
    params: {
        Action: 'DescribeInstances',
        Service,
        Version,
        source
    }
};

export const kecGetProjList = {
    basePath: KecPath,
    params: {
        Action: 'GetAccountProjectList',
        Version: '2015-11-01',
        Service: 'iam',
        source
    },
    method: 'get'
};

//主机搜索新接口
export const kecSearchInstances = {
    basePath: KecPath,
    params: {
        Action: 'SearchInstances',
        Version,
        Service,
        source
    },
    method: 'post'
};

//从回收站恢复实例
export const RecoveryInstances = {
    basePath: KecPath,
    params: {
        Action: 'RecoveryInstances',
        Version,
        Service,
        source
    },
    method: 'post'
};

//删除云服务器
export const DeleteInstances = {
    basePath: KecPath,
    method: 'post',
    params: {
        Action: 'TerminateInstances',
        Service,
        Version,
        source
    }
};
